export default [
  {
    name: 'user-create',
    path: '/users/create',
    component: () => import('@/views/users/UserManage')
  },
  {
    name: 'user-edit',
    path: '/users/:id/edit',
    component: () => import('@/views/users/UserManage')
  },
  {
    name: 'user-view',
    path: '/users/:id/view',
    component: () => import('@/views/users/UserView')
  },
  {
    name: 'user-profile',
    path: '/users/profile/edit',
    component: () => import('@/views/users/UserView')
  },
  {
    name: 'user-find',
    path: '/users/find',
    component: () => import('@/views/users/UserFind')
  },
  {
    name: 'user-profile-edit',
    path: '/users/profile/edit',
    component: () => import('@/views/users/profile/UserProfileManage')
  },
  {
    name: 'user-password-reset',
    path: '/users/password/reset',
    component: () => import('@/views/users/profile/UserProfileManage')
  },
  {
    name: 'user-history',
    path: '/users/history',
    component: () => import('@/views/users/history/UserHistory')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUsers.js